import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import style from './article-subscription.module.scss';
import dynamic from 'next/dynamic';
import { WindowSizeBreakpointsEnum } from '@helpers/window-size-breakpoints';
import { ReactSVG } from 'react-svg';

const StartProjectModal = dynamic(() => import('../../shared/interactions/start-project/start-project.modal'), {
  ssr: false,
});

const ArticleSubscription = () => {
  const handshakeSvg = '/blog-images/handshake.svg';

  const [isModalOpen, setModalOpen] = useState(false);
  const portalRef = useRef<HTMLElement | null>(null);
  const isTabletOrMobile = () => window.innerWidth <= WindowSizeBreakpointsEnum.Tablet;

  useEffect(() => {
    portalRef.current = document.createElement('div');
    document.body.appendChild(portalRef.current);

    return () => {
      portalRef.current && document.body.removeChild(portalRef.current);
    };
  }, []);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleClick = () => {
    if (isTabletOrMobile()) {
      window.location.href = '/contacts';
    } else {
      openModal();
    }
  };

  return (
    <>
      <div className={style.article__subscription__wrapper}>
        <div className={style.article__subscription__title}>
          <div className={style.article__subscription__title__text}>
            <span className={style.article__subscription__title__text__yellow}>Build scalable solutions </span>
            with us. Get started.
          </div>
        </div>
        <button onClick={handleClick} className={style.article__subscription__button}>
          Start building
          <div className={style.article__subscription__button__icon}>
            <ReactSVG src={handshakeSvg} />
          </div>
        </button>
      </div>

      {portalRef.current &&
        createPortal(
          <StartProjectModal
            isOpen={isModalOpen}
            onClose={closeModal}
            successStatusText={{
              title: 'Inquiry submitted',
              text: 'Thanks for your request, we’ll be in touch soon.',
            }}
          />,
          portalRef.current,
        )}
    </>
  );
};

export default ArticleSubscription;
